type StockOrderLabel = {
    title: string;
    key: string;
    isDate: boolean;
    enableOrderBy: boolean;
};

export const StockOrderLabels: StockOrderLabel[] = [
    {
        title: 'Vlootnr',
        key: 'stockNumber',
        isDate: false,
        enableOrderBy: true,
    },
    {
        title: 'Kenteken',
        key: 'licensePlate',
        isDate: false,
        enableOrderBy: true,
    },
    {
        title: 'APK',
        key: 'apkDate',
        isDate: true,
        enableOrderBy: true,
    },
    {
        title: 'Tacho',
        key: 'tachographDate',
        isDate: true,
        enableOrderBy: true,
    },
    {
        title: 'Keuring',
        key: 'examinationDate',
        isDate: true,
        enableOrderBy: true,
    },
    {
        title: 'Laadklep',
        key: 'tailgateDate',
        isDate: true,
        enableOrderBy: true,
    },
    {
        title: 'CFK',
        key: 'cfkExaminationDate',
        isDate: true,
        enableOrderBy: true,
    },
    {
        title: 'Voertuigtype',
        key: 'stockTypeTitle',
        isDate: false,
        enableOrderBy: true,
    },
    {
        title: 'Klant notitie',
        key: 'customerNote',
        isDate: false,
        enableOrderBy: true,
    },
    {
        title: 'Status',
        key: 'appointmentState',
        isDate: false,
        enableOrderBy: true,
    },
];

export enum TaskIdentifiers {
    APK = 'apk',
    TACHOGRAPH = 'tachograph',
    EXAMINATION = 'examination',
    TAILGATE = 'tailgate',
    CFK_EXAMINATION = 'cfk-examination',
    SERVICE = 'service',
}
